import Vue from 'vue/dist/vue.esm.js'
const d = document

const is_input = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_input')
const is_confirm = document.querySelector('.mw_wp_form').classList.contains('mw_wp_form_confirm')

const init = () => {
  const input_template = d.querySelector('#input')
  const input_templateDOM = new DOMParser().parseFromString( input_template.innerHTML, 'text/html' )
  const popy_children = {
    '': '選択してください',
    'ももちゃん': 'ももちゃん 2～3歳児　　980円',
    'きいどり': 'きいどり 年少（3～4歳）　　980円',
    'あかどり': 'あかどり 年中（4～5歳）　　1100円',
    'あおどり': 'あおどり 年長（5～6歳）　　1100円',
    '小学ポピー1年生': '小学ポピー1年生　　2500円',
    '小学ポピー2年生': '小学ポピー2年生　　2900円',
    '小学ポピー3年生': '小学ポピー3年生　　3300円',
    '小学ポピー4年生': '小学ポピー4年生　　3300円',
    '小学ポピー5年生': '小学ポピー5年生　　3800円',
    '小学ポピー6年生': '小学ポピー6年生　　3800円',
    '中学ポピー1年生': '中学ポピー1年生　　4686円',
    '中学ポピー2年生': '中学ポピー2年生　　4787円',
    '中学ポピー3年生': '中学ポピー3年生　　4990円',
    'ENGLISHのみ': 'ENGLISHのみ',
  }
  const pke_children = {
    '': '選択してください',
    'レベル1': 'レベル1：年中～小１｜ 1680円',
    'レベル2': 'レベル2：年長～小２｜ 1680円',
    'レベル3': 'レベル3：小１～小３｜ 1680円',
  }
  const start_children = JSON.parse( input_templateDOM.querySelector('[name="__children[c2-開始月号][]"]').value )
  const school_type_children = {
    '公立': '公立',
    '私立': '私立',
    '国立': '国立',
    'その他': 'その他',
  }
  
  const edit_template = d.querySelector('#child2Edit')
  const edit_templateDOM = new DOMParser().parseFromString( edit_template.innerHTML, 'text/html' )

  $('select[name="c2-月刊ポピー"]',edit_templateDOM).each( (i,obj) => {
    $.each(popy_children, (key,val) => $(obj).append( $(`<option value="${key}">${val}</option>`)[0] ))
  })

  $('select[name="c2-ポピーKidsEnglish"]',edit_templateDOM).each( (i,obj) => {
    $.each(pke_children, (key,val) => $(obj).append( $(`<option value="${key}">${val}</option>`)[0] ))
  })

  $('input[name="c2-開始月号"][type="radio"]',edit_templateDOM).each( (i,obj) => {
    $.each(start_children, (key,val) => $(obj).before( $(`<label><input type="radio" name="c2-開始月号" v-model="editdata.c2start" class="form-check-input" value="${key}">${val}</label>`)[0] ))
    $(obj).remove()
  })

  $('select[name="c2-学校種別"]',edit_templateDOM).each( (i,obj) => {
    $.each(school_type_children, (key,val) => $(obj).append( $(`<option value="${key}">${val}</option>`)[0] ))
  })

  edit_template.innerHTML = edit_templateDOM.body.outerHTML
}

if( is_confirm ) init()

export default Vue.component( 'child2Edit', {
  template: '#child2Edit',
  props:{
    is_input: Boolean,
    is_confirm: Boolean,
    formdata: Object
  },
  data () {
    return {
      editdata: {
        c2popy: this.formdata.c2popy,
        c2pke: this.formdata.c2pke,
        c2popypen: this.formdata.c2popypen,
        c2start: this.formdata.c2start,
        c2name_1: this.formdata.c2name_1,
        c2name_2: this.formdata.c2name_2,
        c2furi_1: this.formdata.c2furi_1,
        c2furi_2: this.formdata.c2furi_2,
        c2birthday: this.formdata.c2birthday,
        c2school_type: this.formdata.c2school_type,
        c2school_name: this.formdata.c2school_name,
        c2school_suffix: this.formdata.c2school_suffix,
      }
    }
  },
  mounted () {
    if( is_input ) this.$router.replace('/')

    // カレンダーセット
    this.setDatepicker()
  },
  methods: {
    update(){
      this.$emit('upd-section', this.editdata)
      this.$router.push('/')
    },
    reduceChild() {
      if( confirm('２人目の情報は送信されません。\nよろしいですか？') ){
        this.$emit('toggle-section','child2')
        this.$router.push('/')
      }
    },
    setDatepicker () {
      // カレンダー
      $('input[type=text][name$="生年月日"]', this.$el).each( (i,obj) => {
        const endDate = new Date()
        const startDate = new Date()
        const defaultViewDate = new Date()

        // 生年月日範囲設定
        startDate.setFullYear( startDate.getFullYear() - 15 )
        defaultViewDate.setFullYear( defaultViewDate.getFullYear() - 2 )

        $(obj).datepicker({
          endDate, // today
          startDate,
          defaultViewDate,
          startView: 'decade',
          language: "ja",
          format: 'yyyy年mm月dd日',
          autoclose: true,
          container: 'body.page'
        }).on('changeDate', e => this.editdata.c2birthday = e.format() )
      })
    }
  },
  computed: {
    school_suffix () {
      switch ( this.editdata.c2popy ){
        case 'ももちゃん':
        case 'きいどり':
        case 'あかどり':
        case 'あおどり':
          return ''

        case '小学ポピー1年生':  case '小学ポピー2年生':  case '小学ポピー3年生':
        case '小学ポピー4年生':  case '小学ポピー5年生':  case '小学ポピー6年生':
          return '小学校'

        case '中学ポピー1年生':  case '中学ポピー2年生':  case '中学ポピー3年生':
          return '中学校'

        default:
          return ''
      }
    },
    is_school () {
      switch ( this.editdata.c2popy ){
        case 'ももちゃん':
        case 'きいどり':
        case 'あかどり':
        case 'あおどり':
          return false

        case '小学ポピー1年生':  case '小学ポピー2年生':  case '小学ポピー3年生':
        case '小学ポピー4年生':  case '小学ポピー5年生':  case '小学ポピー6年生':
        case '中学ポピー1年生':  case '中学ポピー2年生':  case '中学ポピー3年生':
          return true
      }
    }
  }
})


